import { useEffect, useState } from "react";

// マウント時にサーバー同期を1回実行し、完了までローディング表示するためのフラグを返す。
// 施工系ページは「ローカルIndexedDBを即描画→サーバー同期→reloadで再描画」の二段構えのため、
// そのままでは古い内容が一瞬表示されてから差し替わる。呼び出し側は loading と併せて
// このフラグが true の間ローディング画面を出すことで、同期完了後の内容だけを見せる。
// 同期エラー時もフラグは必ず解除する(エラー自体の扱いは従来どおり呼び出し元へ伝播)。
export function useMountSync(enabled: boolean, sync: () => Promise<void>, reload: () => void): boolean {
  const [syncing, setSyncing] = useState(enabled);
  useEffect(() => {
    const run = async () => {
      try {
        if (enabled) {
          await sync();
          // reload は再取得の起動のみ(完了は useFullDb の loading フラグが覆う)
          reload();
        }
      } finally {
        setSyncing(false);
      }
    };
    run();
    // マウント時に1回だけ実行する(従来の各ページの同期 effect と同じ)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return syncing;
}
